var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.collapsedComponent == "zoom"
      ? _c(
          "div",
          {
            class: _vm.expand ? "blue-box-expanded" : "blue-box-collapsed",
            attrs: { id: "expandableZoom" },
          },
          [
            _c("MMP_CollapsedZoom", {
              attrs: {
                expanded: _vm.expand,
                map: _vm.map,
                zoomLevel: _vm.zoomLevel,
              },
              on: {
                click: function ($event) {
                  return _vm.expansionToggle()
                },
                zoomLevelChanged: function ($event) {
                  return _vm.$emit("zoomLevelChanged", $event)
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.collapsedComponent == "coordinates"
      ? _c(
          "div",
          {
            class: _vm.expand ? "blue-box-expanded" : "blue-box-collapsed",
            attrs: { id: "expandableCoordinates" },
          },
          [
            _c("MMP_CollapsedCoordinates", {
              attrs: {
                coords: _vm.coords,
                expanded: _vm.expand,
                map: _vm.map,
                pointVectorSource: _vm.pointVectorSource,
                ansiComponent: _vm.ansiComponent,
                drtComponents: _vm.drtComponents,
                showToggle: _vm.showToggle,
              },
              on: {
                addPoint: function ($event) {
                  return _vm.$emit("addPoint", $event)
                },
                showToggle: function ($event) {
                  return _vm.$emit("showToggle")
                },
                click: function ($event) {
                  return _vm.expansionToggle()
                },
                getVectorlayer: function ($event) {
                  return _vm.$emit("getVectorlayer", $event)
                },
                toggleChange: function ($event) {
                  return _vm.$emit("toggleChange", $event)
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.collapsedComponent == "extents"
      ? _c(
          "div",
          {
            class: _vm.expand ? "blue-box-expanded" : "blue-box-collapsed",
            attrs: { id: "expandableExtents" },
          },
          [
            _c("MMP_CollapsedExtents", {
              attrs: {
                expanded: _vm.expand,
                map: _vm.map,
                selectedExtent: _vm.selectedExtent,
                userOrg: _vm.userOrg,
                baseMapsOpen: _vm.baseMapsOpen,
              },
              on: {
                extentsExpandChange: function ($event) {
                  return _vm.$emit("extentsExpandChange", $event)
                },
                click: function ($event) {
                  return _vm.expansionToggle()
                },
                extentChanged: function ($event) {
                  return _vm.$emit("extentChanged", $event)
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.collapsedComponent == "base"
      ? _c(
          "div",
          {
            ref: "parentBox",
            class: _vm.expand ? "blue-box-expanded" : "blue-box-collapsed",
            attrs: { id: "expandableBaseMaps" },
          },
          [
            _c("MMP_CollapsedBaseMap", {
              attrs: {
                parentRef: _vm.$refs.parentBox,
                currentBaseMap: _vm.currentBaseMap,
                expanded: _vm.expand,
                map: _vm.map,
                isAnsiComponent: _vm.isAnsiComponent,
                extentsOpen: _vm.extentsOpen,
                showLidarPanel: _vm.showLidarPanel,
              },
              on: {
                baseMapsExpandChange: function ($event) {
                  return _vm.$emit("baseMapsExpandChange", $event)
                },
                click: function ($event) {
                  return _vm.expansionToggle()
                },
                toggleBaseLayer: function ($event) {
                  return _vm.$emit("toggleBaseLayer", $event)
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.collapsedComponent == "lidar"
      ? _c(
          "div",
          {
            staticClass: "blue-box-collapsed",
            attrs: { id: "expandableLidarToggle" },
          },
          [
            _c("MMP_CollapsedLidarToggle", {
              attrs: {
                lidarMinZoomAchieved: _vm.lidarMinZoomAchieved,
                showLidarPanel: _vm.showLidarPanel,
              },
              on: {
                lidarToggleChange: function ($event) {
                  return _vm.$emit("lidarToggleChange")
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.collapsedComponent == "measure"
      ? _c(
          "div",
          {
            class: !_vm.showMeasuringTool
              ? "blue-box-collapsed"
              : "blue-box-collapsed measure-blue-box",
            attrs: { id: "expandableMeasureToolToggle" },
            on: {
              click: function ($event) {
                _vm.measureTriggerProp = true
              },
            },
          },
          [
            _c("MMP_CollapsedMeasuringTool", {
              attrs: {
                map: _vm.map,
                measureTriggerProp: _vm.measureTriggerProp,
                showMeasuringTool: _vm.showMeasuringTool,
              },
              on: {
                resetToggleMeasureProp: function ($event) {
                  _vm.measureTriggerProp = false
                },
                toggleMeasuringTool: function ($event) {
                  return _vm.$emit("toggleMeasuringTool")
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }